import axiosClient from "../../../../../system/helpers/axiosConfig";

export const postTranslationImportExcel = (params) => {
  return axiosClient
    .post(`api/translations/import/excel`, params)
    .then((r) => r.data);
};
